<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import FormOptionDisclaimer from '$provider/constants/FormOptionDisclaimer';
  import type { FormOptionDisclaimerType } from '$shared/components/types';
  interface Props {
    list?: FormOptionDisclaimerType[];
  }

  let { list = [] }: Props = $props();
  const getIconValue = (type: FormOptionDisclaimer): string => {
    switch (type) {
      case FormOptionDisclaimer.Info:
        return 'icon-alert-circle';
      case FormOptionDisclaimer.Warn:
        return 'icon-alert-triangle';
      case FormOptionDisclaimer.Error:
        return 'icon-alert-octagon';
      default:
        return '';
    }
  };
</script>

{#if Array.isArray(list) && list?.length !== 0}
  <div class="comp-disclaimers">
    {#each list as item}
      <div data-cy="disclaimer" class="disclaimer">
        <div class="icon">
          <Icon value={getIconValue(item?.type)} />
        </div>
        <div data-cy="disclaimer-text" class="text">{@html item?.text}</div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .comp-disclaimers {
    background-color: var(--grey-bg);
    padding: 0px 6px 16px 36px;
  }
  .disclaimer {
    display: flex;
  }
  .disclaimer:not(:last-child) {
    margin-bottom: 14px;
  }
  .disclaimer .icon {
    margin-right: 6px;
  }
  .disclaimer .text {
    color: var(--grey-dark);
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
  }
</style>
